export class Terceros {
    tercero:string;
    usuario:string;
    conflicto:string;
}
